import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import type { SavedSearch, SavedSearchCriteria } from './types';

export default function SavedSearchBar({ current, onApply }: { current: SavedSearchCriteria; onApply: (c: SavedSearchCriteria) => void; }) {
  const [list, setList] = useState<SavedSearch[]>([]);
  const [open, setOpen] = useState(false);

  const load = () => api.listSavedSearches().then((r) => setList(r.searches || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    const name = window.prompt('Name this search');
    if (!name) return;
    await api.createSavedSearch(name, current).catch(() => {});
    load();
  };
  const remove = async (id: string) => { await api.deleteSavedSearch(id).catch(() => {}); load(); };

  return (
    <div className="relative flex items-center gap-2">
      <button onClick={save} className="px-3 py-1.5 text-sm rounded-full border bg-white text-gray-700 border-gray-300 hover:bg-gray-50">Save search</button>
      <button onClick={() => setOpen(!open)} className="px-3 py-1.5 text-sm rounded-full border bg-white text-gray-700 border-gray-300 hover:bg-gray-50">
        Saved ({list.length})
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-[1200] bg-white border rounded-lg shadow-lg w-64 max-h-80 overflow-y-auto" onMouseLeave={() => setOpen(false)}>
          {list.length === 0 && <p className="p-3 text-sm text-gray-500">No saved searches yet</p>}
          {list.map((s) => (
            <div key={s.id} className="flex items-center justify-between px-3 py-2 hover:bg-gray-50">
              <button className="text-sm text-gray-800 text-left truncate flex-1" onClick={() => { onApply(s.criteria); setOpen(false); }}>{s.name}</button>
              <button className="text-gray-300 hover:text-red-600 text-xs ml-2" onClick={() => remove(s.id)}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
